import { Button, Text } from '@grupoboticario/flora-react';
import { format } from 'date-fns';

import { BiDownload } from 'react-icons/bi';
import { downloadOneFile, getReportsUrls } from 'utils/downloadUrls';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';
import { Details } from './styles';

interface TitleDetailsProps {
  files?: any;
  idCertificate?: string;
  pdvNumber?: string;
}

export function ReportsDetails({
  files,
  idCertificate,
  pdvNumber,
}: Readonly<TitleDetailsProps>) {
  const { cpId } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );

  async function handleDownload(bucketKey?: any) {
    try {
      const filesUrl = await getReportsUrls(
        cpId,
        pdvNumber,
        idCertificate,
        bucketKey,
        idCertificate,
      );
      if (filesUrl) {
        filesUrl.map((item: any) => downloadOneFile(item));
      }
    } catch (err) {
      console.log(err);
    }
  }
  function formatDate(date: Date | string, formatString = 'dd/MM/yyyy') {
    const dateObject = typeof date === 'string' ? new Date(date) : date;
    const year = dateObject.getUTCFullYear();
    const month = dateObject.getUTCMonth();
    const day = dateObject.getUTCDate();

    return format(new Date(year, month, day), formatString);
  }
  return (
    <Details>
      <ul>
        {files.slice(0, -1).map((file: any) => (
          <li key={file.id}>
            <div>
              <Text size="bodyMediumShort">{pdvNumber}</Text>
            </div>
            <div className="button-download">
              <Text size="bodyMediumShort">{formatDate(file.createdAt)}</Text>
              <Button
                aria-label="download-button"
                onClick={() => handleDownload(file.bucketKey)}
                has="iconOnly"
                size="small"
                hierarchy="tertiary"
                icon={<BiDownload />}
              />
            </div>
          </li>
        ))}
      </ul>
    </Details>
  );
}
